export const updateSelectedParameters = (selectedParameters) => {
  return selectedParameters.map((param) => param.toLowerCase().replace(/[\s(),/_°³]+/g, ""));
};
